/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentCompletedEntry
 */
export interface IncidentCompletedEntry {
    /**
     * 
     * @type {number}
     * @memberof IncidentCompletedEntry
     */
    completed: number;
    /**
     * 
     * @type {number}
     * @memberof IncidentCompletedEntry
     */
    total: number;
}

/**
 * Check if a given object implements the IncidentCompletedEntry interface.
 */
export function instanceOfIncidentCompletedEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "completed" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function IncidentCompletedEntryFromJSON(json: any): IncidentCompletedEntry {
    return IncidentCompletedEntryFromJSONTyped(json, false);
}

export function IncidentCompletedEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentCompletedEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'completed': json['completed'],
        'total': json['total'],
    };
}

export function IncidentCompletedEntryToJSON(value?: IncidentCompletedEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'completed': value.completed,
        'total': value.total,
    };
}

